import './project-intro.scss';

export default () => {

};
